import { render } from "./QuotesTable.vue?vue&type=template&id=671be8a8"
import script from "./QuotesTable.vue?vue&type=script&lang=js"
export * from "./QuotesTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/reps.mlelectronics.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__